import { useEffect, useRef, useState } from "react"
import { brackyArenaConfig } from "../data/bracky-arena-config"

export function useBrackyAnimation() {
  const [isVisible, setIsVisible] = useState(false)
  const [hasAnimated, setHasAnimated] = useState(false)
  const [shouldAnimate, setShouldAnimate] = useState(false)
  const sectionRef = useRef<HTMLElement>(null)
  const prevValuesRef = useRef<Record<string, number>>({})

  // Activate counters once the component scrolls into view
  useEffect(() => {
    const io = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return
        setIsVisible(entry.isIntersecting)
        // Only trigger animation on first intersection or when values change
        if (entry.isIntersecting && !hasAnimated) {
          setShouldAnimate(true)
          setHasAnimated(true)
        }
      },
      { threshold: brackyArenaConfig.animation.intersectionThreshold },
    )
    if (sectionRef.current) io.observe(sectionRef.current)
    return () => io.disconnect()
  }, [hasAnimated])

  // Reset shouldAnimate after animation completes
  useEffect(() => {
    if (shouldAnimate) {
      const timer = setTimeout(() => {
        setShouldAnimate(false)
      }, brackyArenaConfig.animation.animationDuration)
      return () => clearTimeout(timer)
    }
    return undefined
  }, [shouldAnimate])

  return {
    isVisible,
    shouldAnimate,
    setShouldAnimate,
    sectionRef,
    prevValuesRef,
  }
}
